import { render } from "./CompanyPrinciples.vue?vue&type=template&id=d72139ae&scoped=true&ts=true"
import script from "./CompanyPrinciples.vue?vue&type=script&lang=ts"
export * from "./CompanyPrinciples.vue?vue&type=script&lang=ts"

import "./CompanyPrinciples.vue?vue&type=style&index=0&id=d72139ae&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d72139ae"]])

export default __exports__